import { InputText } from '@dixa/lib-shared-habla';
import {
  ChangeEventHandler,
  Dispatch,
  forwardRef,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';

type CategorizedListSearch = {
  /** The search value. */
  value?: string;
  /** The callback for whenever the search term changes. */
  onSearchChange: (searchTerm: string) => void;
  /** The setter for changing whether the search is focused. */
  setIsSearchFocused: Dispatch<SetStateAction<boolean>>;
};

/** Represents a search input for filtering the categories. */
export const CategorizedListSearch = forwardRef<
  HTMLInputElement,
  CategorizedListSearch
>(function CategorizedListSearch(
  { value: initialValue = '', setIsSearchFocused, onSearchChange },
  ref,
): JSX.Element {
  const [value, setValue] = useState(initialValue);

  /** Handles changing the search. */
  const handleSearchChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      const { value } = event.target;
      setValue(value);
      onSearchChange?.(value);
    },
    [onSearchChange],
  );

  useEffect(() => setValue(initialValue), [initialValue]);

  return (
    <InputText
      ref={ref}
      icon="search"
      placeholder="Search"
      value={value}
      onFocus={() => setIsSearchFocused(true)}
      onBlur={() => setIsSearchFocused(false)}
      onChange={handleSearchChange}
    />
  );
});
